// 2项目管理角色

const prjectManagerAuth = [
	{
		icon: "iconfont icon-shouye-shouye",
		router: "/admin/index",
		name: "首页",
	},
	{
		icon: "iconfont icon-xiangmuguanli",
		router: "/admin/project",
		name: "项目管理",
	},
	{
		icon: "iconfont icon-jianxiujihua",
		router: "/admin/device",
		name: "设备管理",
	},
	// {
	// 	icon: "iconfont icon-ludeng",
	// 	router: "/admin/task",
	// 	name: "任务管理",
	// },
  {
    icon:"icon icon-renwujihua",
    router:'/admin/task',
    name:'任务日志',
    children:[
      {
        icon: "iconfont icon-ludeng",
        router: "/admin/task",
        name: "任务日志",
      },{
        icon:"iconfont icon-jiancejilu-xian",
        router:"/admin/DetectionRecord",
        name:"检测记录",
      }
    ]
  }
]
export default prjectManagerAuth
